import React, { useEffect, useState } from "react";
import api, { formatDate } from "@/lib/api";

const TABS = [
  { key: "applications", label: "Contribute Applications", endpoint: "/admin/applications" },
  { key: "nominations", label: "Nominations", endpoint: "/admin/nominations" },
  { key: "subscribers", label: "Newsletter Subscribers", endpoint: "/admin/subscribers" },
  { key: "contact", label: "Contact Messages", endpoint: "/admin/contact" },
];

export default function AdminSubmissions() {
  const [tab, setTab] = useState("applications");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    setLoading(true);
    const current = TABS.find((t) => t.key === tab);
    api.get(current.endpoint).then((r) => setData((d) => ({ ...d, [tab]: r.data }))).finally(() => setLoading(false));
  }, [tab]);

  const items = data[tab] || [];

  return (
    <div data-testid="admin-submissions">
      <div className="eyebrow text-oc-coral mb-2">Submissions</div>
      <h1 className="font-editorial text-4xl text-oc-ink">Incoming</h1>

      <div className="mt-8 flex flex-wrap gap-2 border-b border-oc-hairline">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`px-4 py-3 font-ui text-xs font-bold uppercase tracking-widest border-b-2 -mb-px ${
              tab === t.key ? "border-oc-blue text-oc-blue" : "border-transparent text-oc-ink-muted hover:text-oc-ink"
            }`}
          >
            {t.label} <span className="text-oc-ink-muted">({(data[t.key] || []).length})</span>
          </button>
        ))}
      </div>

      <div className="mt-8">
        {loading ? (
          <div className="py-16 text-center">Loading...</div>
        ) : items.length === 0 ? (
          <div className="py-16 text-center font-ui text-sm text-oc-ink-muted">No {tab} yet.</div>
        ) : (
          <div className="border border-oc-hairline divide-y divide-oc-hairline">
            {items.map((it) => (
              <div key={it.id} className="grid grid-cols-12 gap-4 px-6 py-4 items-center hover:bg-oc-sand/50">
                <div className="col-span-4">
                  <div className="font-ui font-semibold text-sm">
                    {it.name || it.your_name || it.nominee_name || it.email || it.subject}
                  </div>
                  <div className="font-ui text-xs text-oc-ink-muted">{it.email || it.your_email}</div>
                </div>
                <div className="col-span-6 font-ui text-sm text-oc-ink-soft line-clamp-2">
                  {it.company || it.nominee_company || it.subject || it.interest || it.why_featured || it.message || ""}
                </div>
                <div className="col-span-1 font-ui text-xs text-oc-ink-muted">{formatDate(it.created_at)}</div>
                <div className="col-span-1 text-right">
                  <button onClick={() => setOpen(it)} className="font-ui text-xs font-bold uppercase tracking-widest text-oc-blue hover:text-oc-ink">
                    View
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-start justify-center p-4 overflow-y-auto" onClick={() => setOpen(null)}>
          <div className="bg-white w-full max-w-2xl p-8 my-16" onClick={(e) => e.stopPropagation()}>
            <div className="eyebrow text-oc-coral mb-2">{tab}</div>
            <h3 className="font-editorial text-2xl text-oc-ink mb-6">Submission detail</h3>
            <dl className="space-y-4">
              {Object.entries(open).filter(([k]) => !["_id", "id"].includes(k)).map(([k, v]) => (
                <div key={k} className="grid grid-cols-3 gap-4 pb-3 border-b border-oc-hairline">
                  <dt className="eyebrow text-oc-ink-muted">{k.replace(/_/g, " ")}</dt>
                  <dd className="col-span-2 font-editorial text-base text-oc-ink whitespace-pre-wrap">{String(v || ", ")}</dd>
                </div>
              ))}
            </dl>
            <button onClick={() => setOpen(null)} className="mt-6 h-11 px-5 border border-oc-ink font-ui text-xs font-bold uppercase tracking-widest">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
